import React, { useEffect, useState } from "react";

function InventoryModal({ show, handleClose, handleSave, item }) {
    const [formData, setFormData] = useState({
        name: "",
        type: "",
        quantity: "",
        price: "",
        warrantyType: "NONE",
        warrantyPeriod: "", // Ensure this key matches
    });

    useEffect(() => {
        if (item) {
            setFormData({
                name: item.name || "",
                type: item.type || "",
                quantity: item.quantity || "",
                price: item.price || "",
                warrantyType: item.warrantyType || "NONE",
                warrantyPeriod: item.warrantyPeriod || "", // Populate with item value
            });
        }
    }, [item]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        handleSave(formData); // Pass updated form data to the parent component
    };

    return (
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 transition-opacity ${show ? "opacity-100" : "opacity-0 pointer-events-none"}`}
            onClick={handleClose}
        >
            <div
                className="bg-white rounded-lg shadow-lg p-6 w-96"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex justify-between items-center">
                    <h3 className="text-xl font-semibold text-blue-600">{item ? "Edit Inventory Item" : "Add Inventory Item"}</h3>
                    <button
                        onClick={handleClose}
                        className="text-gray-500 hover:text-red-500"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M11.3 10.7a1 1 0 0 0 0-1.4L8.4 8l2.9-2.9a1 1 0 1 0-1.4-1.4L7 6.6 4.1 3.7a1 1 0 1 0-1.4 1.4L6.6 8l-2.9 2.9a1 1 0 0 0 0 1.4 1 1 0 0 0 1.4 0L8 9.4l2.9 2.9a1 1 0 0 0 1.4 0z"/>
                        </svg>
                    </button>
                </div>
                <form onSubmit={onSubmit} className="mt-4 space-y-4">
                    <div>
                        <label htmlFor="formName" className="block text-gray-700 font-semibold">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            id="formName"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="formType" className="block text-gray-700 font-semibold">Category</label>
                        <input
                            type="text"
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            required
                            id="formType"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="formQuantity" className="block text-gray-700 font-semibold">Quantity</label>
                        <input
                            type="number"
                            name="quantity"
                            value={formData.quantity}
                            onChange={handleChange}
                            required
                            id="formQuantity"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="formPrice" className="block text-gray-700 font-semibold">Price</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            required
                            id="formPrice"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div>
                        <label htmlFor="warrantyType" className="block text-gray-700 font-semibold">Warranty Type</label>
                        <select
                            name="warrantyType"
                            value={formData.warrantyType}
                            onChange={handleChange}
                            id="warrantyType"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            <option value="NONE">None</option>
                            <option value="WARRANTY">WARRANTY</option>
                            <option value="AMC">AMC</option>
                        </select>
                    </div>
                    <div>
                        <label htmlFor="formWarrantyPeriod" className="block text-gray-700 font-semibold">Warranty Period</label>
                        <input
                            type="number"
                            name="warrantyPeriod"
                            value={formData.warrantyPeriod}
                            onChange={handleChange}
                            disabled={formData.warrantyType === "NONE"}
                            required={formData.warrantyType !== "NONE"}
                            id="formWarrantyPeriod"
                            className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>
                    <div className="mt-6 flex justify-end space-x-4">
                        <button
                            type="button"
                            onClick={handleClose}
                            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-700 focus:outline-none"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 focus:outline-none"
                        >
                            {item ? "Update" : "Add"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default InventoryModal;
